/* Bioniks - favoriler (localStorage) + drawer sekmesi */
(function () {
  var KEY = 'bioniks_wishlist';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
  }

  function fmtTRY(cents) {
    var v = (Number(cents) / 100).toFixed(2).split('.');
    return '\u20BA' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
  }

  function setTab(tab) {
    window.dispatchEvent(new CustomEvent('bioniks-set-tab', { detail: tab }));
  }

  function openDrawer(tab) {
    if (tab) setTab(tab);
    var target = document.getElementById('offcanvasRight');
    if (!target) return;
    document.querySelectorAll('.offcanvas').forEach(function (el) {
      el.classList.add('is-closed');
    });
    target.classList.remove('is-closed');
    if (!document.querySelector('.offcanvas-backdrop')) {
      var backdrop = document.createElement('div');
      backdrop.className = 'offcanvas-backdrop';
      backdrop.addEventListener('click', function () {
        backdrop.remove();
        document.querySelectorAll('.offcanvas').forEach(function (el) {
          el.classList.add('is-closed');
        });
      });
      document.body.appendChild(backdrop);
    }
  }

  function updateCounts(count) {
    document.querySelectorAll('.js-wishlist-count').forEach(function (el) {
      el.textContent = count;
    });
  }

  function syncActiveButtons(list) {
    var ids = {};
    list.forEach(function (p) { ids[String(p.id)] = true; });
    document.querySelectorAll('.js-wishlist-add').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.classList.toggle('active', !!ids[id]);
      btn.classList.toggle('is-wishlisted', !!ids[id]);
    });
  }

  function itemHTML(item) {
    return '' +
      '<li data-wish-id="' + item.id + '">' +
        '<div class="py-5 border-b border-border">' +
          '<div class="flex items-center justify-center">' +
            '<div class="size-20 rounded-3xl relative overflow-hidden mr-4">' +
              '<a href="' + item.url + '"><img src="' + (item.image || '') + '" alt="" width="80" height="80" class="w-full"></a>' +
            '</div>' +
            '<div class="mr-5 flex-[1]">' +
              '<h6 class="mb-2 font-medium"><a href="' + item.url + '">' + item.title + '</a></h6>' +
              '<div class="flex items-center"><h6 class="font-medium">' + fmtTRY(item.price) + '</h6></div>' +
            '</div>' +
            '<a href="javascript:void(0);" class="js-wishlist-remove size-7 flex items-center" data-product-id="' + item.id + '">' +
              '<i class="ti-close"></i>' +
            '</a>' +
          '</div>' +
        '</div>' +
      '</li>';
  }

  function render(list) {
    var ul = document.getElementById('dz-wishlist-items');
    if (!ul) return;
    if (!list.length) {
      ul.innerHTML = '<li class="py-10 text-center text-title js-wishlist-empty">Favori listeniz bo\u015F.</li>';
    } else {
      ul.innerHTML = list.map(itemHTML).join('');
    }
    updateCounts(list.length);
    syncActiveButtons(list);
  }

  function productFromBtn(btn) {
    return {
      id: btn.getAttribute('data-product-id'),
      handle: btn.getAttribute('data-product-handle') || '',
      title: btn.getAttribute('data-product-title') || '',
      url: btn.getAttribute('data-product-url') || '#',
      image: btn.getAttribute('data-product-image') || '',
      price: parseInt(btn.getAttribute('data-product-price'), 10) || 0
    };
  }

  function toggle(btn, openPanel) {
    var p = productFromBtn(btn);
    if (!p.id) return;
    var list = read();
    var idx = list.findIndex(function (x) { return String(x.id) === String(p.id); });
    if (idx >= 0) {
      list.splice(idx, 1);
    } else {
      list.unshift(p);
    }
    write(list);
    render(list);
    if (openPanel && idx < 0) openDrawer('wishlist');
  }

  function bindDrawerTabs() {
    document.querySelectorAll('.offcanvas-btn[data-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tab = btn.getAttribute('data-tab');
        if (tab) setTab(tab);
      });
    });
  }

  function bind() {
    bindDrawerTabs();
    render(read());

    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest && e.target.closest('.js-wishlist-add');
      if (addBtn) {
        e.preventDefault();
        e.stopPropagation();
        toggle(addBtn, true);
        return;
      }
      var rm = e.target.closest && e.target.closest('.js-wishlist-remove');
      if (rm) {
        e.preventDefault();
        var id = rm.getAttribute('data-product-id');
        var list = read().filter(function (x) { return String(x.id) !== String(id); });
        write(list);
        render(list);
      }
    });
  }

  window.BioniksWishlist = { open: openDrawer, toggle: toggle, list: read, render: render };

  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
})();
